<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
          패턴
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WMDS</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Pattern</a>
          </li>
      </ul>
    </div>
    <b-card>
      <!-- <template slot="header">
        <i class='fa fa-align-justify'></i> 패턴 목록
      </template> -->
      <!-- detail search start -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> 등록일
                <b-button size="sm" variant="info" @click="set_sd('', 'created_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'created_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'created_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'created_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'created_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'created_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <p> 사용여부 </p>
            <c-switch color="success" label size="sm" v-model="so.opt['is_alive']" @change="refresh" />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group label="위험도" label-for="code_ext" v-b-tooltip.hover>
              <b-form-checkbox-group v-model="so.opt['level']" @change="refresh">
                <b-form-checkbox value="H">위험</b-form-checkbox>
                <b-form-checkbox value="W">경고</b-form-checkbox>
                <b-form-checkbox value="N">주의</b-form-checkbox>
                <b-form-checkbox value="S">의심</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="정책" label-for="code_type" v-b-tooltip.hover>
              <b-form-checkbox-group v-model="so.opt['type']" @change="refresh">
                <b-form-checkbox value="U">URL</b-form-checkbox>
                <b-form-checkbox value="S">문자열</b-form-checkbox>
                <b-form-checkbox value="R">정규식</b-form-checkbox>
                <b-form-checkbox value="M">MD5</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="12">
            <label for="ph_search_opt_type">검색 옵션</label>
            <b-form-group>
              <b-form-radio-group v-model="so.opt['match_type']" @change="($event) = so.opt = Object.assign({}, so.opt, { match_type : $event })" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:모두 포함</b-form-radio>
                <b-form-radio value="or">[OR]:하나라도 포함</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group class="float-right">
          <b-button class="btn-add" size="sm" variant="success" @click="refresh"> 검색 </b-button>
          <b-button size="sm" variant="warning" @click="reset"> 초기화 </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> 닫기 </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->

      <b-row>
        <b-col sm="12">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset"><i class="fa fa-remove"></i></b-btn>
              <b-input-group-text size="sm" variant="outline-secondary">코드</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="so.adv = !so.adv; so.sv = ''"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"> 상세검색</i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" ref="_list" show-empty empty-text="not found." class="table-responsive table_add"
        :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="level" slot-scope="row">{{codes.WMDS_LEVEL_PATTERN[row.item.level]}}</template>
        <template slot="type" slot-scope="row">{{codes.WMDS_TYPE[row.item.type]}}</template>
        <template slot="code" slot-scope="row">
          <a href="javascript:void(0)" class="a_tag" @click="detail(row.item)">
            {{row.item.code | truncate(40)}}
          </a>
        </template>
        <template slot="created_at" slot-scope="row">{{row.item.created_at | date}}</template>
        <template slot="is_alive" slot-scope="row">
          <b-badge v-if="row.item.is_alive == true" variant="success">사용</b-badge>
          <b-badge v-else>미사용</b-badge>
        </template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">더 보기</b-btn>
        </template>
      </b-table>
      <hr>
      <b-row>
        <b-col md="3">
        </b-col>
        <b-col md="5">
          <b-pagination size="sm"  align="center" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
        </b-col>
        <b-col md="4">
          <div class="pull-right">
            <b-button size="sm" :limit="10" class="btn-add" variant="success" @click="$router.push({ name: 'wmds_pattern', params: { id : 'add' } })"> 등록 </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <!-- <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view> -->
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
